<template>
    <div>
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <!--<v-avatar size="120" class="mr-6">
                        <img
                            class=""
                            src="/img/database.c82dbe43.svg"
                            alt=""
                        />
                    </v-avatar>-->
                    <div class="flex-1">
                        <div class="d-flex align-start justify-space-between">
                            <div class="mb-3">
                                <h5 class="mr-2 mb-0">
                                    Cluster: {{ title }}                                   
                                </h5>
                                <span></span>                                
                                <p class="text--disabled mb-0">{{ description }}</p>
                            </div>
                            <div>
                                
                            </div>
                        </div>
                        <!--<div class="d-flex mb-2">
                            <p class="ma-0 mr-8">
                                <span class="font-weight-medium"></span
                                >
                            </p>
                        </div>
                        <p class="text--disabled">
                            {{ contact_name }}
                        </p>-->
                    </div>
                    <div class="flex-1 text-right">
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="save">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-row justify="center">     
            <!-- <v-form  v-model="editFormValid" ref="editForm">        -->
            <v-col cols="10" md="5">
                <e-info-card
                    title="Primary Fields"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <v-form  v-model="editFormValid" ref="editForm">
                            <v-list>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Title" 
                                            v-model="title"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                            @input="handleTitleInput"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Short Description" 
                                            v-model="description"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-textarea
                                            label="Description"
                                            v-model="long_description"
                                            auto-grow
                                            rows="2"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="cluster_type"
                                            :items="type_items"                 
                                            label="Cluster Type" 
                                            item-text="selecttext"
                                            item-value="selectvalue"    
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="network"
                                            :items="networkOptions"                 
                                            label="Network"                                                                                                                                       
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item> 
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="placement_type"
                                            :items="placementOptions"                 
                                            label="Placement Type"                                                                                                                                       
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content class="pt-0">
                                        <v-autocomplete
                                            v-model="network_owner_code"
                                            :items="networkOwnerOptions"
                                            label="Network Owner"
                                            item-text="text"
                                            item-value="value"
                                            :loading="mediaOptionsLoading"
                                            :disabled="networkOwnerOptions.length === 0"
                                            clearable
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content class="pt-0">
                                        <v-autocomplete
                                            v-model="media_category_code"
                                            :items="filteredMediaCategoryOptions"
                                            label="Media Category"
                                            item-text="text"
                                            item-value="value"
                                            :loading="mediaOptionsLoading"
                                            :disabled="filteredMediaCategoryOptions.length === 0"
                                            clearable
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content class="pt-0">
                                        <v-autocomplete
                                            v-model="media_channel_code"
                                            :items="filteredMediaChannelOptions"
                                            label="Media Channel"
                                            item-text="text"
                                            item-value="value"
                                            :loading="mediaOptionsLoading"
                                            :disabled="filteredMediaChannelOptions.length === 0"
                                            clearable
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content class="pt-0">
                                        <v-autocomplete
                                            v-model="media_placement_code"
                                            :items="filteredMediaPlacementOptions"
                                            label="Media Placement"
                                            item-text="text"
                                            item-value="value"
                                            :loading="mediaOptionsLoading"
                                            :disabled="filteredMediaPlacementOptions.length === 0"
                                            clearable
                                        />
                                    </v-list-item-content>
                                </v-list-item> 
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Cost" 
                                            v-model.number="cost"
                                            type="number"
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="cost_type"
                                            :items="costTypeOptions"                 
                                            label="Cost Type"                                             
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                            </v-list>  
                        </v-form>                      
                    </template>
                </e-info-card>
            </v-col>
            <v-col cols="10" md="5">

                


                <v-form  v-model="additionalCostFormValid" ref="additionalCostForm">
                <e-info-card
                    class="mt-4"
                    title="Additional Cost Types"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-alert v-if="errorMessage != null && errorMessage != ''" type="error">
                            {{ errorMessage }}
                        </v-alert>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Cost Type</th>
                                    <th>Cost</th>                                    
                                    <th>&nbsp;</th>             
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ct in additional_cost_types" :key="ct.cost_type">
                                    <td>{{ getOptionDescription(costTypeOptions, ct.cost_type) }}</td>
                                    <td><v-text-field style="width: 100px;" :rules="requiredRules" v-model.number="ct.cost" type="number"></v-text-field></td>                                    
                                    <td><v-btn icon small @click="removeCostType(ct)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                                </tr>
                            </tbody>
                            
                        </v-simple-table>
                        <cost-type-selector-dropdown @itemselected="addCostType" :cost_type="cost_type"></cost-type-selector-dropdown>
                    </template>
                </e-info-card>
                </v-form>

                
            </v-col>
            <!-- </v-form> -->
            <!--<v-col cols="10" md="5">
                <e-info-card
                    title="Associated Users"                    
                >
                    <template slot="basic-info-slot">
                       
                    </template>
                </e-info-card>
            </v-col>-->
        </v-row>
        <v-row justify="center">
            <v-col cols="10" md="8">
                <e-info-card
                    class="mt-4"
                    title="Target Audiences"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-alert v-if="audienceError" type="error">
                            {{ audienceError }}
                        </v-alert>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Audience</th>
                                    <th>Rationale</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audience, index) in targetAudiences" :key="'aud-'+ index">
                                    <td style="width: 500px;">
                                        <v-select
                                            :items="audienceOptions"
                                            v-model="audience.audience_code"
                                            item-text="text"
                                            item-value="value"
                                            label="Audience"
                                            dense
                                            hide-details
                                            clearable
                                            :disabled="audienceOptions.length === 0"
                                        />
                                    </td>
                                    <td>
                                        <v-text-field
                                            label="Rationale"
                                            v-model="audience.rationale"
                                            hide-details
                                        />
                                    </td>
                                    <td class="text-right">
                                        <v-btn icon small @click="removeAudienceRow(index)">
                                            <v-icon small>mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="targetAudiences.length === 0">
                                    <td colspan="3" class="text-center text--disabled py-4">
                                        No audiences selected yet.
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-btn class="mt-4" small color="primary" @click="addAudienceRow" :disabled="audienceOptions.length === 0">
                            <v-icon left small>mdi-plus</v-icon>
                            Add Audience
                        </v-btn>
                    </template>
                </e-info-card>
            </v-col>
        </v-row>
        <v-row v-if="!createMode" justify="center">
            <v-col cols="12" md="12">
                <e-info-card
                    :title="'Cluster Adpoints: ' + adpointsTotalNo + ' Total'"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <adpoints-grid-component :cluster="parseInt($route.params.code)" @setTotal="setAdpointsTotalNo"></adpoints-grid-component>
                    </template>
                </e-info-card>
            </v-col>
        </v-row>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js"
import AdpointsGridComponent from '@/views/settings/adpoints-grid-component';
import { getOptionDescription } from "@/core/ui-utils.js"
//import { costTypeOptions } from "@/core/refdata-utils.js";
import CostTypeSelectorDropdown from "@/components/core/CostTypeSelectorDropdown";
import { costTypeOptions } from '../../core/refdata-utils';

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Brand Edit'
    },
    components: {
        avatarGroupCard,
        EInfoCard,
        AdpointsGridComponent,
        CostTypeSelectorDropdown
    },
    data() {
        return {
            //primary data       
            adpointsTotalNo: 0,     
            title: '',
            description: '',
            long_description: '',
            titleManuallyEdited: false,
            cluster_type: '',
            network: '',
            placement_type: '',
            network_owner_code: null,
            media_category_code: null,
            media_channel_code: null,
            media_placement_code: null,
            cost: null,
            cost_type: null,
            additional_cost_types: [],
            targetAudiences: [],
            audienceOptions: [],
            audienceError: '',
            // contact_phoneno: '',
            crud_code: '',
            disabled: false,
            //ui mechanics  
            additionalCostFormValid: true,    
            createMode: false,                  
            invitationFormValid: true,
            editFormValid: true,
            brand_to_add: '',
            //error
            errorMessage: '',
            loading: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            //reference data
            costTypeOptions: [...costTypeOptions],
            networkOptions: [],
            placementOptions: [],
            networkOwnerOptions: [],
            mediaCategoryOptions: [],
            mediaChannelOptions: [],
            mediaPlacementOptions: [],
            mediaOptionsLoading: false,
            mediaOptionsInitialized: false,
            type_items: [
                {
                    selectvalue: "physical",
                    selecttext: "Online",
                },                
                {
                    selectvalue: "static",
                    selecttext: "Offline",
                },
                {
                    selectvalue: "web",
                    selecttext: "Web",
                },                      
            ],
            brand_list_items: [],                                    
            roles_list_items: [
                        {
                            selectvalue: "admin",
                            selecttext: "Admin",
                        },
                        {
                            selectvalue: "viewer",
                            selecttext: "Viewer",
                        },
                        {
                            selectvalue: "designer",
                            selecttext: "Designer",
                        },
                        {
                            selectvalue: "dev",
                            selecttext: "Developer",
                        },
                        {
                            selectvalue: "sysadmin",
                            selecttext: "System Admin",
                        }
                    ],
            firstNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            requiredRules: [
                fieldNotEmpty                
            ],
        }
    },
    computed: {
        status() {
            return (this.disabled) ? "Disabled" :
                    (this.invitation_code) ? "Invited" :
                    (this.activation_date === "" || this.activation_date == null) ? "Awaiting Activation" : "Active";                    
        },
        filteredMediaCategoryOptions() {
            return this.mediaCategoryOptions;
        },
        filteredMediaChannelOptions() {
            if(!this.media_category_code) {
                return this.mediaChannelOptions;
            }
            return this.mediaChannelOptions.filter(opt => opt.media_category_code === this.media_category_code);
        },
        filteredMediaPlacementOptions() {
            if(!this.media_channel_code) {
                return this.mediaPlacementOptions;
            }
            return this.mediaPlacementOptions.filter(opt => opt.media_channel_code === this.media_channel_code);
        }
    },
    watch: {
        network_owner_code() {
            this.normalizeMediaSelections();
            this.autoFillTitle();
        },
        media_category_code() {
            this.normalizeMediaSelections();
            this.autoFillTitle();
        },
        media_channel_code() {
            this.normalizeMediaSelections();
            this.autoFillTitle();
        },
        media_placement_code() {
            this.autoFillTitle();
        }
    },
    async created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;       
            this.createMode = false;     
        }
        else {            
            this.createMode = true;
        }

        const rsp = await api.adpoint.getInitData();
        this.networkOptions = rsp.data.networkOptions.map(d=> ({...d, value: d.value.toString()}));        
        this.placementOptions = rsp.data.deviceTypeOptions.map(d=> ({...d, value: d.value.toString()}));
        this.audienceOptions = (rsp.data.audienceOptions || []).map(d=> ({...d, value: d.value != null ? d.value.toString() : d.value}));
        this.loadMediaTaxonomyOptions();
    },
    async mounted() {
        // const rsp = await api.brand.getAll();            
        // this.brand_list_items = rsp.data.map(i=> {return {...i, selectvalue: i.code, selecttext: i.title}});
        if(!this.createMode) {
            const rspB = await api.cluster.getOne(this.crud_code);
            if(rspB && rspB.data) {            
                this.title = rspB.data.title;
                this.description = rspB.data.description;
                this.titleManuallyEdited = !!(this.title && this.title.trim().length > 0);
                this.long_description = rspB.data.long_description;
                this.cost = rspB.data.cost;
                this.cluster_type = rspB.data.cluster_type;
                this.network = rspB.data.network;
                this.placement_type = rspB.data.placement_type;
                this.cost_type = rspB.data.cost_type;            
                this.additional_cost_types = rspB.data.additional_cost_types;
                this.network_owner_code = rspB.data.network_owner_code || (rspB.data.networkOwner ? rspB.data.networkOwner.code : null);
                this.media_category_code = rspB.data.media_category_code || (rspB.data.mediaCategory ? rspB.data.mediaCategory.code : null);
                this.media_channel_code = rspB.data.media_channel_code || (rspB.data.mediaChannel ? rspB.data.mediaChannel.code : null);
                this.media_placement_code = rspB.data.media_placement_code || (rspB.data.mediaPlacement ? rspB.data.mediaPlacement.code : null);
                this.targetAudiences = (rspB.data.audiences || []).map(a => ({
                    audience_code: a.audience_code || (a.audience ? a.audience.code : null),
                    rationale: a.rationale || ''
                }));
                
                // this.contact_name = rspB.data.contact_name;
                // this.contact_email = rspB.data.contact_email;
                // this.contact_phoneno = rspB.data.contact_phoneno;            
            }
        }
        //this.editFormValid = true;
    },
    methods: {
        handleTitleInput() {
            if(!this.titleManuallyEdited) {
                this.titleManuallyEdited = true;
            }
        },
        getOptionTitleByValue(options, value) {
            if(!value) {
                return '';
            }
            const option = options.find(opt => opt.value === value);
            if(!option) {
                return '';
            }
            if(option.title && option.title.length > 0) {
                return option.title;
            }
            return option.text || '';
        },
        autoFillTitle() {
            if(this.titleManuallyEdited) {
                return;
            }
            const parts = [];
            const ownerTitle = this.getOptionTitleByValue(this.networkOwnerOptions, this.network_owner_code);
            const categoryTitle = this.getOptionTitleByValue(this.mediaCategoryOptions, this.media_category_code);
            const channelTitle = this.getOptionTitleByValue(this.mediaChannelOptions, this.media_channel_code);
            const placementTitle = this.getOptionTitleByValue(this.mediaPlacementOptions, this.media_placement_code);
            if(ownerTitle) {
                parts.push(ownerTitle);
            }
            if(categoryTitle) {
                parts.push(categoryTitle);
            }
            if(channelTitle) {
                parts.push(channelTitle);
            }
            if(placementTitle) {
                parts.push(placementTitle);
            }
            this.title = parts.join(' | ');
        },
        normalizeMediaSelections() {
            if(!this.mediaOptionsInitialized) {
                return;
            }
            if(!this.filteredMediaCategoryOptions.some(opt => opt.value === this.media_category_code)) {
                this.media_category_code = null;
            }
            if(!this.filteredMediaChannelOptions.some(opt => opt.value === this.media_channel_code)) {
                this.media_channel_code = null;
            }
            if(!this.filteredMediaPlacementOptions.some(opt => opt.value === this.media_placement_code)) {
                this.media_placement_code = null;
            }
        },
        async loadMediaTaxonomyOptions() {
            this.mediaOptionsLoading = true;
            try {
                const [ownersRsp, categoriesRsp, channelsRsp, placementsRsp] = await Promise.all([
                    api.networkowner.getList("?currentPage=1&limit=1000"),
                    api.mediacategory.getAll(),
                    api.mediachannel.getAll(),
                    api.mediaplacement.getAll()
                ]);
                const owners = ownersRsp?.data?.data || ownersRsp?.data || [];
                const categories = categoriesRsp?.data || [];
                const channels = channelsRsp?.data || [];
                const placements = placementsRsp?.data || [];
                this.networkOwnerOptions = owners
                    .map(i => ({
                        value: i.code || i.value || (i.id != null ? i.id.toString() : ''),
                        text: i.title || i.text,
                        title: i.title || i.text,
                    }))
                    .filter(opt => typeof opt.value === 'string' && opt.value.length > 0);
                this.mediaCategoryOptions = categories.map(i => ({
                    value: i.code,
                    text: i.title,
                    title: i.title
                }));
                this.mediaChannelOptions = channels.map(i => ({
                    value: i.code,
                    text: i.mediaCategory && i.mediaCategory.title
                        ? i.title + ' (' + i.mediaCategory.title + ')'
                        : i.title,
                    title: i.title,
                    media_category_code: i.media_category_code || (i.mediaCategory ? i.mediaCategory.code : null)
                }));
                this.mediaPlacementOptions = placements.map(i => ({
                    value: i.code,
                    text: i.mediaChannel && i.mediaChannel.title
                        ? i.title + ' (' + i.mediaChannel.title + ')'
                        : i.title,
                    title: i.title,
                    media_channel_code: i.media_channel_code || (i.mediaChannel ? i.mediaChannel.code : null)
                }));
            }
            catch(error) {
                this.snackbarColor = "red";
                this.snackbarMessage = (error && error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : "Failed to load media metadata.";
                this.snackbar = true;
            }
            finally {
                this.mediaOptionsLoading = false;
                this.mediaOptionsInitialized = true;
                this.normalizeMediaSelections();
                this.autoFillTitle();
            }
        },
        async addCostType(item) {
            this.errorMessage="";
            const rsp = await srvApi.put(PATH.CLUSTER_ADDCOSTTYPE + '/' + this.crud_code, item);
            if(!rsp.data.success) {
                this.errorMessage=rsp.data.message;                
            }
            else {
                this.additional_cost_types.splice(0, this.additional_cost_types.length);
                this.additional_cost_types.push(...rsp.data.data/*.map(r=>({...r, editMode: false}))*/);            
            }            
        },
        async removeCostType(item) {
            this.errorMessage="";
            const rsp = await srvApi.put(PATH.CLUSTER_REMOVECOSTTYPE + '/' + this.crud_code, item);
            if(!rsp.data.success) {
                this.errorMessage=rsp.data.message;   
            }
            else {
                this.additional_cost_types.splice(0, this.additional_cost_types.length);
                this.additional_cost_types.push(...rsp.data.data/*.map(r=>({...r, editMode: false}))*/);
            }               
        },
        addAudienceRow() {
            this.targetAudiences.push({
                audience_code: null,
                rationale: ''
            });
        },
        removeAudienceRow(index) {
            this.targetAudiences.splice(index, 1);
        },
        validateAudienceSelections() {
            this.audienceError = '';
            if(this.targetAudiences.length === 0) {
                return true;
            }
            if(this.targetAudiences.some(entry => !entry.audience_code)) {
                this.audienceError = "Please select an audience for every row.";
                return false;
            }
            const codes = this.targetAudiences.map(entry => entry.audience_code);
            if((new Set(codes)).size !== codes.length) {
                this.audienceError = "Duplicate audiences are not allowed.";
                return false;
            }
            return true;
        },
        buildAudiencePayload() {
            return this.targetAudiences
                .filter(entry => entry && entry.audience_code)
                .map(entry => ({
                    audience_code: entry.audience_code,
                    rationale: entry.rationale || ''
                }));
        },
        getOptionDescription,
        setAdpointsTotalNo(totalNo) {
            this.adpointsTotalNo=totalNo;
        },
        save() {
            let el = this.$el.querySelector(':focus');
            if (el) {
                console.log('blur');
                el.blur();
            }        
            
            for(let inp of this.$refs.editForm.inputs) {
                console.log('inp');
                inp.blur();
            }

            //this.editFormValid=true;
            this.error = '';     
            this.editFormValid = this.$refs.editForm.validate();                          
            if(!this.editFormValid) {                
                this.snackbarColor = "red";
                this.snackbarMessage = "There are invalid fields.";
                this.snackbar = true;
                return;
            }                                
            if(!this.validateAudienceSelections()) {
                this.snackbarColor = "red";
                this.snackbarMessage = this.audienceError;
                this.snackbar = true;
                return;
            }
            this.loading = true;   
            this.errorMessage="";
            const payload = {      
                title: this.title,
                description: this.description,
                long_description: this.long_description,
                    network_owner_code: this.network_owner_code,
                media_category_code: this.media_category_code,
                media_channel_code: this.media_channel_code,
                media_placement_code: this.media_placement_code,
                cost: this.cost,
                cost_type: this.cost_type,
                additional_cost_types: this.additional_cost_types,
                cluster_type: this.cluster_type,
                network: this.network,
                placement_type: this.placement_type,
                audiences: this.buildAudiencePayload()
            };
            if(this.createMode) {
                api.cluster.create(payload)
                .then((rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;  
                    if(!rsp.data.success) {
                        this.errorMessage=rsp.data.message;     
                    }
                    else {
                        this.$router.push("/mng/adpoints/clusters/");
                    }                    
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }  
            else {
                api.cluster.update(this.crud_code, payload)
                .then((rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;  
                    if(!rsp.data.success) {
                        this.errorMessage=rsp.data.message;     
                    }
                    else {
                        this.$router.push("/mng/adpoints/clusters/");   
                    }                    
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }                 
        },       
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
</style>
